import ShippingBatchDownload from './ShippingBatchDownload';
import React, {useRef,useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next"
import { setFilters, resetFilters} from 'reducers/filtersShippingsSlice';
import { resetPagination } from 'reducers/paginationShippingsSlice';
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT, LIMIT_PAGE,MAX_PDF,MAX_ZIP,CONFIRM_CODE } from "constants/variables";
import { setLoading } from "reducers/loadingSlice";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import MenuItem  from "@mui/material/MenuItem"; 
import SendIcon from "@mui/icons-material/Send";
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingShipping from "pages/shipping/filterShipping/SortingTablesShipping";
import ShippingPDF from "pages/shipping/generatePDF/ShippingPDF";
import exportToExcel from "pages/shipping/filterShipping/ShippingFormDIView/ShippingExportToExcel";
import exportToSAGE from "pages/shipping/filterShipping/ShippingFormDIView/ShippingExportToSage";
import exportToPDF from "pages/shipping/filterShipping/ShippingExportToPDF";
import FormDIView from "pages/shipping/filterShipping/ShippingFormDIView/FormDIShipping";
import PropTypes from 'prop-types'; 

const initialFiltersShippings= {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  numberShippingFrom:"",
  numberShippingTo:"",
  dateShippingFrom:null,
  dateShippingTo:null,
  ori_tras_store_idFrom:"",
  ori_tras_store_idTo:"",
  dest_tras_store_idFrom:"",
  dest_tras_store_idTo:"",
  rel_trans_store_idFrom:"",
  rel_trans_store_idTo:"",
  vehicleFrom:"",
  vehicleTo:""
};
  
const initialStoresToSelect = [{ id: "", documentid: "", tradename: "" }]; 
const initialVehicleToSelect = [{ id: "", vehiclestore_licenseplate: "" }];

const initialStateShipping = [{
  id : 0,
  ownshipping_id:0,
  defaultStore_id : 0,
  tradename : "",
  useraccount_id : 0,
  username :"",
  defaultformatnumber: 1,
  number_shipping:"",
  date_shipping : "",
  opt_tras_store_id : 0,
  opt_tras_tradename : "",
  dest_tras_store_id : 0,
  dest_tras_tradename : "",
  rel_trans_store_id : 0,
  rel_trans_tradename : "",
  vehiclestore_licenseplate : "",
  totalamount : 0,
  formdi_id:0,
  ownformdi_id:0,
  isPending: true,
  isFinished: false
}];

const upper = (v) => String(v ?? "").toUpperCase();
const safeLower = (v) => (v ?? "").toString().toLowerCase();
const isBlank = (v) => String(v ?? "").trim() === "";
const stripVehicle = (v) => upper(v).replace(/[.-]/g, "");
const stripSymbols = (v) => (v ?? "").toString().replace(/[.\-/\\|]/g, "").trim();

const buildMenuPermissions = (roles) => {
  const list = (roles ?? []).flatMap((role) => role?.listmenus ?? []);
  const has = (name) => list.some((m) => m.name === name);
  return {
    canFormCreate: has('SubMenu_Shipping_Create'),
    canFormEdit: has('SubMenu_Shipping_Edit'),
    canViewCheck: has('SubMenu_Shipping_VIEW_Check'),
    canFormPrint: has('SubMenu_Shipping_Print'),
    canFormExcel: has('SubMenu_Shipping__Handle_Excel'),
    canFormSage: has('SubMenu_Shipping__Handle_SAGE'),
    canFormDelete: has('SubMenu_Shipping_Delete'),
    canFormEmail: has('SubMenu_Shipping_Handle_EMAILs'), 
    canEnded: has("SubMenu_Shipping_Ended"),
    canShipping: has('SubMenu_Shipping_Handle_FORMS'), 
    canStoreMaster: has('SubMenu_Settings_Shippings_Store_Master'),
    canUserMaster: has('SubMenu_Settings_Shippings_User_Master'),
    canDriverMaster: has('SubMenu_Settings_Shippings_Person'),
    canViewPrice: has('View_Prices_Shipping'),
    canViewFormDI: has('View_FormDi_Shipping'),
    canViewReference: has('View_Reference_Shipping'),
    canViewOptTras: has('View_OptTras_Shipping'),
    canAutoDeca: has('SubMenu_Shipping_DECA'),
    canDecaHistory: has('SubMenu_Shipping_DECA_History')
  };
};

const scrollToIndex = (containerSelector, index) => {
  const dropdown = document.querySelector(containerSelector);
  const item = dropdown?.children?.[index];
  if (item) {
    item.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
};
 
const useDebouncedCallback = (cb, delay = 300) => {
  const cbRef = useRef(cb);
  const tRef = useRef(null);
  useEffect(() => {
    cbRef.current = cb;
  }, [cb]);
  useEffect(() => {
    return () => {
      if (tRef.current) clearTimeout(tRef.current);
    };
  }, []);
  return useCallback(
    (...args) => {
      if (tRef.current) clearTimeout(tRef.current);
      tRef.current = setTimeout(() => cbRef.current(...args), delay);
    },
    [delay]
  );
};

const useRangeAutocomplete = ({
  list,
  getLabel,
  getSecondaryLabel,
  fromValue,
  toValue,
  setFromValue,
  setToValue,
  allowToItem = () => true,
  normalizeExact = (v) => upper(v),
  normalizeInput = (v) => upper(v),
  dropdownSelector = ".dropdown-class",
}) => {
  const [filteredFrom, setFilteredFrom] = useState([]);
  const [hiFrom, setHiFrom] = useState(-1);
  const [filteredTo, setFilteredTo] = useState([]);
  const [hiTo, setHiTo] = useState(-1);
  const debouncedSearchFrom = useDebouncedCallback((searchValue) => {
    const q = upper(searchValue);
    if (isBlank(q)) {
      setFilteredFrom([]);
      setHiFrom(-1);
      return;
    }
    const filtered = (list ?? [])
      .filter((it) => it && getLabel(it))
      .filter((it) => {
        const a = upper(getLabel(it));
        const b = upper(getSecondaryLabel?.(it));
        return a.includes(q) || b.includes(q);
      })
      .slice(0, 20);
    setFilteredFrom(filtered);
    setHiFrom(filtered.length ? 0 : -1);
  }, 300);
  const debouncedSearchTo = useDebouncedCallback((searchValue) => {
    const q = upper(searchValue);
    if (isBlank(q)) {
      setFilteredTo([]);
      setHiTo(-1);
      return;
    }
    const filtered = (list ?? [])
      .filter((it) => allowToItem(it))
      .filter((it) => it && getLabel(it))
      .filter((it) => {
        const a = upper(getLabel(it));
        const b = upper(getSecondaryLabel?.(it));
        return a.includes(q) || b.includes(q);
      })
      .slice(0, 20);
    setFilteredTo(filtered);
    setHiTo(filtered.length ? 0 : -1);
  }, 300);
  const selectFrom = useCallback(
    (item) => {
      if (!item) return;
      const value = getLabel(item) || "";
      setFromValue(value);
      setToValue(value);   // ✅ siempre sincroniza
      setFilteredFrom([]);
      setHiFrom(-1);
    },
    [getLabel, setFromValue, setToValue]
  );
  const selectTo = useCallback(
    (item) => {
      if (!item) return;
      const value = getLabel(item) || "";
      setToValue(value);
      setFilteredTo([]);
      setHiTo(-1);
    },
    [getLabel, setToValue]
  );

  const keyDownFrom = useCallback(
    (event) => {
      if (event.key === "ArrowDown") {
        if (filteredFrom.length === 0 && isBlank(fromValue)) {
          setFilteredFrom(list ?? []);
          setHiFrom(0);
        } else {
          setHiFrom((prev) => {
            const next = prev < filteredFrom.length - 1 ? prev + 1 : prev;
            scrollToIndex(dropdownSelector, next);
            return next;
          });
        }
      } else if (event.key === "ArrowUp") {
        setHiFrom((prev) => {
          const next = prev > 0 ? prev - 1 : prev;
          scrollToIndex(dropdownSelector, next);
          return next;
        });
      } else if ((event.key === "Enter" || event.key === "Tab") && hiFrom >= 0) {
        if (hiFrom < filteredFrom.length) selectFrom(filteredFrom[hiFrom]);
      } else if (event.key === "Escape") {
        const isValid = (list ?? []).some((it) => {
          const label = getLabel(it);
          if (!label) return false;
          return normalizeExact(label) === normalizeInput(fromValue);
        });
        if (!isValid) setFromValue("");
        setFilteredFrom([]);
        setHiFrom(-1);
      }
    },[dropdownSelector,filteredFrom,fromValue,getLabel,hiFrom,list,normalizeExact,normalizeInput,selectFrom,setFromValue,]
  );

  const keyDownTo = useCallback(
    (event) => {
      if (event.key === "ArrowDown") {
        if (filteredTo.length === 0 && isBlank(toValue)) {
          setFilteredTo((list ?? []).filter((it) => allowToItem(it)));
          setHiTo(0);
        } else {
          setHiTo((prev) => {
            const next = prev < filteredTo.length - 1 ? prev + 1 : prev;
            scrollToIndex(dropdownSelector, next);
            return next;
          });
        }
      } else if (event.key === "ArrowUp") {
        setHiTo((prev) => {
          const next = prev > 0 ? prev - 1 : prev;
          scrollToIndex(dropdownSelector, next);
          return next;
        });
      } else if ((event.key === "Enter" || event.key === "Tab") && hiTo >= 0) {
        if (hiTo < filteredTo.length) selectTo(filteredTo[hiTo]);
      } else if (event.key === "Escape") {
        const isValid = (list ?? [])
          .filter((it) => allowToItem(it))
          .some((it) => {
            const label = getLabel(it);
            if (!label) return false;
            return normalizeExact(label) === normalizeInput(toValue);
          });
        if (!isValid) setToValue("");
        setFilteredTo([]);
        setHiTo(-1);
      }
    },[dropdownSelector,filteredTo,getLabel,hiTo,list,normalizeExact,normalizeInput,selectTo,setToValue,toValue,allowToItem,]
  );

  const clearAll = useCallback(() => {
    setFilteredFrom([]);
    setHiFrom(-1);
    setFilteredTo([]);
    setHiTo(-1);
  }, []);

  return {
    filteredFrom,
    hiFrom,
    filteredTo,
    hiTo,
    debouncedSearchFrom,
    debouncedSearchTo,
    selectFrom,
    selectTo,
    keyDownFrom,
    keyDownTo,
    clearAll,
    setFilteredFrom,
    setHiFrom,
    setFilteredTo,
    setHiTo,
  };
}; 
            
const ShippingFilter = ({ showModalShippingsSettings,setShowModalShippingsSettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataShipping']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DELETE_CODE_SHIPPING = useSelector((state) => state.formatDIUser.delete_code_formdi); 
  const filtersShippingsDetails = useSelector((state) => state.filtersShippings);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const isEndedList = typeOfList !== "1" && typeOfList !== "3";
  const endedFlag = isEndedList ? true : false;
  const menuPermissions = useMemo(
    () => buildMenuPermissions(roles),
    [roles]
  );
  const [dataShipping, setDataShipping] = useState(initialStateShipping); 
  const [formPShipping, setFormPShipping] = useState(initialStateShipping[0]);
  const [filtersShipping, setFiltersShipping]= useState(filtersShippingsDetails);
  const [filterUsers, setFilterUsers] = useState([]);
  const [downloadJob, setDownloadJob] = useState(null);
  const downloadBusy = useRef(false);

  const [errorsFiltersShipping, setErrorsFiltersShipping] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegShipping,setNumTotRegShipping]= useState(0);
  const [inputTextShipping, setInputTextShipping] = useState("");  
  const [openDeleteRowShipping,setOpenDeleteRowShipping]= useState(false); 
  const [openEditFilterShipping,setOpenEditFilterShipping]= useState(false);
  const [openViewFormDI,setOpenViewFormDI]= useState(false);    
  const [rowEditShipping,setRowEditShipping]= useState(initialStateShipping[0]);
  const [isLoadingErrorShipping, setIsLoadingErrorShipping] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const [viewPDF,setViewPDF]=useState(false);  
  const [activeOffsetShipping, setActiveOffsetShipping]= useState(false);
  const [currencyOffsetShipping, setCurrencyOffsetShipping] = useState(0);
  const [rangeOffsetShipping, setRangeOffsetShipping] = useState([{}]);
  const [idCodeReturn, setIdCodeReturn] = useState("");
  const [openReturnRowShipping, setOpenReturnRowShipping] = useState(false);
  const [numberCopy,setNumberCopy]=useState(1);
  const [refeshData, setRefeshData] = useState(false); 
  const [destTrasToSelect,setDestTrasToSelect]= useState(initialStoresToSelect); 
  const [tradenameToSelect,setTradenameToSelect]= useState(initialStoresToSelect); 
  const [trasnporterToSelect,setTrasnporterToSelect]= useState(initialStoresToSelect); 
  const [vehiclesToSelect,setVehiclesToSelect]= useState(initialVehicleToSelect);   
  
  const [openCopyRowShipping,setOpenCopyRowShipping]= useState(false);   

  useEffect(() => {
    const refreshAfterDecaGeneration = () => setRefeshData(true);
    window.addEventListener('shipping-deca-generated', refreshAfterDecaGeneration);
    return () => window.removeEventListener(
      'shipping-deca-generated',
      refreshAfterDecaGeneration
    );
  }, []);
  
  const resetAll = useCallback(() => {
    setDataShipping(initialStateShipping); 
    setFormPShipping(initialStateShipping[0]);
    setNumTotRegFilter(0);
    setNumTotRegShipping(0);
    setErrorsFiltersShipping({});
    setInputTextShipping(""); 
    setOpenDeleteRowShipping(false);  
    setOpenEditFilterShipping(false);
    setRowEditShipping(initialStateShipping[0]);
    setIsLoadingErrorShipping(false);
    setIdCodeDelete(DELETE_CODE);
    setViewPDF(false);
    setOpenViewFormDI(false);
    setActiveOffsetShipping(false);
    setCurrencyOffsetShipping(0);
    setRangeOffsetShipping([{}]);
    setIdCodeReturn("");
    setOpenReturnRowShipping(false); 
    setOpenCopyRowShipping(false);
    setNumberCopy(1);
    setRefeshData(false); 
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersShipping(filtersShipping);
    setDestTrasToSelect(initialStoresToSelect);
    setTrasnporterToSelect(initialStoresToSelect);
    setTradenameToSelect(initialStoresToSelect);
    setVehiclesToSelect(initialVehicleToSelect); 
  }, [DELETE_CODE, dispatch,filtersShipping]);
  
  const closeModalShipping = useCallback(() => {
    resetAll();
    setShowModalShippingsSettings(false);
    navigate("/home");
  }, [navigate, setShowModalShippingsSettings, resetAll]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && showModalShippingsSettings) {
        closeModalShipping();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [showModalShippingsSettings, closeModalShipping]);
 
  const validateFormFilterShipping = useCallback(() => {
    const errors = {};
    const regexNumber = /^[0-9]+$/;
    const regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    const num = (v) => (isBlank(v) ? null : Number(v));
    // id from/to
    if (!isBlank(filtersShipping.idFrom) && !regexNumber.test(filtersShipping.idFrom))
      errors.idFrom = "Text_TextNoNumber";
    if (!isBlank(filtersShipping.idTo) && !regexNumber.test(filtersShipping.idTo))
      errors.idTo = "Text_TextNoNumber";
    if (!errors.idFrom && !errors.idTo) {
      const a = num(filtersShipping.idFrom);
      const b = num(filtersShipping.idTo);
      if (a !== null && b !== null && b < a) errors.idTo = "Text_TextGreater_Id";
    }
    if (!isBlank(filtersShipping.defaultStoreIdTo) && filtersShipping.defaultStoreIdTo < filtersShipping.defaultStoreIdFrom)
      errors.defaultStoreIdTo = "Text_TextGreater_Store";
    if (!isBlank(filtersShipping.useraccountIdTo) && filtersShipping.useraccountIdTo < filtersShipping.useraccountIdFrom)
      errors.useraccountIdTo = "Text_TextGreater_UserAccount";
  
    // invalid chars
    if (regexInvalidCharacters.test(filtersShipping.numberShippingFrom))
      errors.numberShippingFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersShipping.numberShippingTo))
      errors.numberShippingTo = "Text_TextNoValid";
    
    if ( !isBlank(filtersShipping.numberShippingTo) && filtersShipping.numberShippingTo < filtersShipping.numberShippingFrom)
      errors.numberShippingTo = "Text_TextGreater_numberShippingTo";

    if (filtersShipping.dateShippingTo!==null & filtersShipping.dateShippingTo<filtersShipping.dateShippingFrom){
      errors.dateShippingTo = 'Text_TextGreater_Date';
    }
    return errors;
  }, [filtersShipping]); 

  const openEditFiltersShipping = useCallback(() => {
    setOpenEditFilterShipping((v) => !v);
  }, []);

   const handleSubmitFilterEditShipping = useCallback(() => {
    const errs = validateFormFilterShipping();
    setErrorsFiltersShipping(errs);
    if (Object.keys(errs).length === 0) {
      dispatch(resetPagination());
      dispatch(setFilters(filtersShipping));
      setErrorsFiltersShipping(false);
      setOpenEditFilterShipping(false);
    } else {
      dispatch(warningErrorAction(t("Text_Error_Filter")));
    }
  }, [dispatch, filtersShipping, t, validateFormFilterShipping]);

  const handleDeleteFiltersShipping = useCallback(() => {
    setErrorsFiltersShipping({});
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersShipping(initialFiltersShippings);
    setOpenEditFilterShipping((v) => !v);
  }, [dispatch]);

  const handleCancelFiltersShipping = useCallback(() => {
    setErrorsFiltersShipping({});
    setOpenEditFilterShipping((v) => !v);
  }, []); 

  const handleChangeFilterEditShipping = useCallback((e) => {
    const { name, value } = e.target;
    setFiltersShipping((p) => ({
      ...p,
      [name]: value,
      ...(name === 'useraccountIdFrom' && value && p.useraccountIdTo && p.useraccountIdTo < value
        ? { useraccountIdTo: '' }
        : {}),
    }));
  }, []);

  const handleBlurFilterEditShipping = useCallback(
    (e) => {
      handleChangeFilterEditShipping(e);
      setErrorsFiltersShipping(validateFormFilterShipping());
    },
    [handleChangeFilterEditShipping, validateFormFilterShipping]
  );

  const handleChangeSelectDateShipping = useCallback((date) => {
    const newDate = date ? new Date(date) : null;
    if (newDate && Number.isNaN(newDate.getTime())) return;
    setFiltersShipping((p) => ({ ...p, dateShippingFrom: newDate }));
  }, []);

  const handleChangeSelectDateShippingTo = useCallback((date) => {
    const newDate = date ? new Date(date) : null;
    if (newDate && Number.isNaN(newDate.getTime())) return;
    setFiltersShipping((p) => ({ ...p, dateShippingTo: newDate }));
  }, []); 

  const handleBlurSelectDateShippingFrom = useCallback(
    (e) => {
      handleChangeSelectDateShipping(e);
      setErrorsFiltersShipping(validateFormFilterShipping());
    },
    [handleChangeSelectDateShipping, validateFormFilterShipping]
  );

  const handleBlurSelectDateShippingTo = useCallback(
    (e) => {
      handleChangeSelectDateShippingTo(e);
      setErrorsFiltersShipping(validateFormFilterShipping());
    },
    [handleChangeSelectDateShippingTo, validateFormFilterShipping]
  );
    
  const toggleDrawerFilterEditShipping = (open) => (event) => {
    if (event?.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
    if (event?.type === "keydown") event.preventDefault();  
    dispatch(setLoading(false));
    setIsLoadingErrorShipping(false);
  };

  const openCreateOrEditDataShipping = useCallback(() => {
    setInputTextShipping("");
    setOpenEditFilterShipping((v) => !v);
    navigate(typeOfList === "1" ? "/shippingdetail/0" : typeOfList === "2" ? "/shippingdetailended/0" : "/shippingdetailhome/0");
  }, [navigate, typeOfList]);
  
  const filteredDataShipping = useMemo(() => {
   if (!dataShipping?.length) return dataShipping;
    const search = safeLower(inputTextShipping).trim();
    if (!search) return dataShipping;
    return dataShipping.filter((el) => {
      const dataTranslate =
        String(el.id || '') +
        String(el.number_shipping || '')+
        String(el.opt_tras_tradename || '')+
        String(el.dest_tras_tradename || '')+
        String(el.rel_trans_tradename || '')+
        String(el.vehiclestore_licenseplate || '')+
        String(el.totalamount ? parseFloat(el.totalamount).toFixed(2) : "");
      return safeLower(dataTranslate).includes(search);
    });
  }, [dataShipping, inputTextShipping]);

  // Tradename ORI (From/To)
  const oriAuto = useRangeAutocomplete({
    list: tradenameToSelect,
    getLabel: (s) => s?.tradename ?? "",
    getSecondaryLabel: (s) => s?.documentid ?? "",
    fromValue: filtersShipping.ori_tras_store_idFrom,
    toValue: filtersShipping.ori_tras_store_idTo,
    setFromValue: (v) =>
      setFiltersShipping((p) => ({
        ...p,
        ori_tras_store_idFrom: v, 
        ori_tras_store_idTo: p.ori_tras_store_idTo || v,
      })),
    setToValue: (v) =>
    setFiltersShipping((p) => ({ ...p, ori_tras_store_idTo: v })),
    allowToItem: (s) =>
      (s?.tradename ?? "") >= (filtersShipping.ori_tras_store_idFrom ?? ""),
  });

  // Transportista (From/To)
  const transAuto = useRangeAutocomplete({
    list: trasnporterToSelect,
    getLabel: (s) => s?.tradename ?? "",
    getSecondaryLabel: (s) => s?.documentid ?? "",
    fromValue: filtersShipping.rel_trans_store_idFrom,
    toValue: filtersShipping.rel_trans_store_idTo,
    setFromValue: (v) =>
    setFiltersShipping((p) => ({
        ...p,
        rel_trans_store_idFrom: v,
        rel_trans_store_idTo: p.rel_trans_store_idTo || v,
      })),
    setToValue: (v) =>
    setFiltersShipping((p) => ({ ...p, rel_trans_store_idTo: v })),
    allowToItem: (s) =>
      (s?.tradename ?? "") >= (filtersShipping.rel_trans_store_idFrom ?? ""),
  });

  // Vehículos (From/To)
  const vehicleAuto = useRangeAutocomplete({
    list: vehiclesToSelect,
    getLabel: (v) => v?.vehiclestore_licenseplate ?? "",
    getSecondaryLabel: () => "",
    fromValue: filtersShipping.vehicleFrom,
    toValue: filtersShipping.vehicleTo,
    setFromValue: (v) =>
      setFiltersShipping((p) => ({
        ...p,
        vehicleFrom: v,
        vehicleTo: p.vehicleTo || v,
      })),
    setToValue: (v) =>
    setFiltersShipping((p) => ({ ...p, vehicleTo: v })),
    allowToItem: (v) =>
      (v?.vehiclestore_licenseplate ?? "") >= (filtersShipping.vehicleFrom ?? ""),
    normalizeExact: (v) => stripVehicle(v),
    normalizeInput: (v) => stripVehicle(v),
  });

   // Tradename DEST (From/To)
  const destAuto = useRangeAutocomplete({
    list: destTrasToSelect,
    getLabel: (s) => s?.tradename ?? "",
    getSecondaryLabel: (s) => s?.documentid ?? "",
    fromValue: filtersShipping.dest_tras_store_idFrom,
    toValue: filtersShipping.dest_tras_store_idTo,
    setFromValue: (v) =>
      setFiltersShipping((p) => ({
        ...p,
        dest_tras_store_idFrom: v, 
        dest_tras_store_idTo: p.dest_tras_store_idTo || v,
      })),
    setToValue: (v) =>
    setFiltersShipping((p) => ({ ...p, dest_tras_store_idTo: v })),
    allowToItem: (s) =>
      (s?.tradename ?? "") >= (filtersShipping.dest_tras_store_idFrom ?? ""),
  });

  const handleBlurAutocomplete = useCallback((event) => {
    if (!event?.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      oriAuto.clearAll();
      destAuto.clearAll();
      transAuto.clearAll();
      vehicleAuto.clearAll();
    }
  }, [oriAuto, transAuto, vehicleAuto,destAuto]);
  
  /* -------------------------- Carga listas (ORI/TRANS/DEST) -------------------------- */
  useEffect(() => {
    let alive = true;
    if (!showModalShippingsSettings) return; 
    const fetchDestTradename = async () => {
      try {
        const getData = await  helpHttp().get11( ENDPOINT,`shipping/getlistdesttrastradename`,token, endedFlag);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setDestTrasToSelect(getData);
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      } 
    }; 
    const fetchTradename = async () => {
      try {
        const getData = await helpHttp().get11(ENDPOINT,`shipping/getlistoritrastradename`, token,  endedFlag  );
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setTradenameToSelect(getData);
      } catch {
         if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      } 
    };
    const fetchTransporter = async () => {
      try {
        const getData = await helpHttp().get11(ENDPOINT, `shipping/getlistreltranstradename`,  token,  endedFlag);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setTrasnporterToSelect(getData);
      } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      } 
    };
    fetchTradename();
    fetchTransporter();
    fetchDestTradename();
    return () => {
      alive = false;
    };
  }, 
  [dispatch, endedFlag, i18n.language, showModalShippingsSettings, t, token]); 
 
  /* -------------------------- Carga vehículos (depende TRANS) -------------------------- */
  useEffect(() => {
    let alive = true;
    if (!showModalShippingsSettings) return; 
    const fetchVehicles = async () => {
      try {
        const from = stripSymbols(filtersShipping.rel_trans_store_idFrom) || "-1";
        const to = stripSymbols(filtersShipping.rel_trans_store_idTo) || "-1";
        const getData = await helpHttp().get7(ENDPOINT, "shipping/getlisvehicles", token, from, to, endedFlag);
        if (!alive) return;
        if (getData?.err) dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        else setVehiclesToSelect(getData);
     } catch {
        if (alive) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    };
    fetchVehicles();
    return () => {
      alive = false;
    };
  }, [dispatch, endedFlag, filtersShipping.rel_trans_store_idFrom, filtersShipping.rel_trans_store_idTo, showModalShippingsSettings, t, token]);
 
  const handleCloseDataEditShipping = useCallback(() => { 
    setOpenCopyRowShipping(false);
    setNumberCopy(1);
    dispatch(setLoading(false));
    setIsLoadingErrorShipping(false);
    setRefeshData(false);
  }, [dispatch]);

  const openModalReturn = useCallback(() => setOpenReturnRowShipping(true), []);

  const handleFinishSelectedShipping = useCallback(
    async (e) => {
      if (idCodeReturn !== CONFIRM_CODE) {
        dispatch(warningErrorAction(t("Text_InvalidCodeConfirm")));
        return;
      }
      if (e?.key === "Escape") return;
      dispatch(setLoading(true));
      try {
        const dataToSend = filteredDataShipping.filter((item) => !item.annulled && (item.isPending === true || item.isFinished === true));
        const getData = !endedFlag
          ? await helpHttp().put(ENDPOINT, "shipping/finishshipping", token, dataToSend)
          : await helpHttp().put(ENDPOINT, "shipping/returnshipping", token, dataToSend);

        if (getData?.status === "OK") {
          dispatch(successErrorAction(!endedFlag ? t("Text_Finished") : t("Text_Pending")));
          setIdCodeReturn("");
          setOpenReturnRowShipping(false);
          setIsLoadingErrorShipping(false); 
          setRefeshData(true);
        } else {
          dispatch(warningErrorAction(t(getData?.cause)));
        }
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
        dispatch(setLoading(false));
      } 
    },
    [dispatch, endedFlag, filteredDataShipping, idCodeReturn, t, token]
  );

   useEffect(() => {
    if (numTotRegShipping > Number(LIMIT_PAGE)) {
      setActiveOffsetShipping(true);
      const newRange = [
        {
          value: 0,
          label: ` 1 - ${Number(LIMIT_PAGE).toLocaleString("de-DE")}`,
        },
      ];
      for (
        let i = Number(LIMIT_PAGE);
        i < numTotRegShipping;
        i += Number(LIMIT_PAGE)
      ) {
        newRange.push({
          value: i,
          label: ` ${(i + 1).toLocaleString("de-DE")} - ${(
            i + Number(LIMIT_PAGE)
          ).toLocaleString("de-DE")}`,
        });
      }
      setRangeOffsetShipping(newRange);
    } else {
      setCurrencyOffsetShipping(0);
      setActiveOffsetShipping(false);
      setRangeOffsetShipping([{}]);
    }
  }, [numTotRegShipping]);

  useEffect(() => {
    if (!showModalShippingsSettings) {
      setFormPShipping(initialStateShipping[0]);
      return;
    }
    const r = rowEditShipping || {};
    setFormPShipping((p) => ({
      ...p,
      id: r.id ?? "",
      ownshipping_id: r.ownshipping_id ?? 0,
      defaultStore_id: r.defaultStore_id ?? 0,
      useraccount_id: r.useraccount_id ?? 0,
      username: r.username ?? "",
      defaultformatnumber: r.defaultformatnumber ?? 0,
      number_shipping: r.number_shipping ?? "",
      date_shipping: r.date_shipping ?? "",
      opt_tras_store_id: r.opt_tras_store_id ?? 0,
      opt_tras_tradename: r.opt_tras_tradename ?? "",
      dest_tras_store_id: r.dest_tras_store_id ?? 0,
      dest_tras_tradename: r.dest_tras_tradename ?? "",
      rel_trans_store_id: r.rel_trans_store_id ?? 0,
      rel_trans_tradename: r.rel_trans_tradename ?? "",
      vehiclestore_licenseplate: r.vehiclestore_licenseplate ?? "",
      totalamount: r.totalamount ?? 0,
      formdi_id: r.formdi_id ?? 0,
      ownformdi_id: r.ownformdi_id ?? 0,
      isPending: r.isPending ?? true,
      isFinished: r.isFinished ?? false
    }));
  }, [rowEditShipping, showModalShippingsSettings]);

  const completeDownload = useCallback(() => {
    downloadBusy.current = false;
    setDownloadJob(null);
    dispatch(setLoading(false));
  }, [dispatch]);
  const failDownload = useCallback(() => {
    completeDownload();
    dispatch(warningErrorAction(t('Text_IncorrectData')));
  }, [completeDownload, dispatch, t]);
  const downloadSelectedShipping = (mode) => {
    if (downloadBusy.current || !menuPermissions.canFormExcel) return;
    const selected = filteredDataShipping.filter((row) => !row.annulled && (endedFlag ? row.isPending === true : row.isFinished === true));
    if (!selected.length) { dispatch(warningErrorAction(t('Text_NoSelection'))); return; }
    const limit = mode === 'zip' ? MAX_ZIP : MAX_PDF;
    if (selected.length > limit) { dispatch(warningErrorAction(t('Text_SHIPPING_DownloadLimit', { count: limit }))); return; }
    downloadBusy.current = true;
    setDownloadJob({ rows: selected, mode });
    dispatch(setLoading(true));
  };

  const handleSendEmailList = useCallback((e) => {
    if (e?.key === "Escape") return;
    const selected = filteredDataShipping.filter((item) => !item.annulled && (item.isPending === true || item.isFinished === true));
    if (selected.length === 0) {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t("Text_NoSelection")));
      return;
    }
    if (selected.length > MAX_PDF) {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t("Text_MaxSelectionExceeded")));
      return;
    } 
    const targetRoute =
      typeOfList === "1"
        ? "/shippinglistsendemaillist":
        typeOfList === "2"?
        "/shippinglistsendemaillistended":
        "/shippinglistsendemaillistbegin";
    navigate(targetRoute, {
      state: {
        selected
      }
    });
  }, [filteredDataShipping, dispatch, navigate, t,typeOfList]);

 const fetchRegisterBook = useCallback(
    async (path) => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post6(ENDPOINT,path,token,currencyOffsetShipping,LIMIT_PAGE,"-1","-1",endedFlag,filtersShippingsDetails);
        if (getData?.err) {
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          return null;
        }
        dispatch(setLoading(false));
        return getData;
      } catch (e) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
         dispatch(setLoading(false));
        return null;
      } 
    },
    [dispatch, token, currencyOffsetShipping, endedFlag, filtersShippingsDetails, t]
  );

  const handleExportPDF = useCallback(async () => {
    if (!dataShipping?.length) return;
    const data = await fetchRegisterBook("shipping/shippingslisttopdfs");
    if (data?.length) exportToPDF(data, "RegistroCartasPortes", !!menuPermissions.canViewPrice);
  }, [dataShipping, fetchRegisterBook, menuPermissions.canViewPrice]);

  const resolveCountFilterRequest = useCallback(async () => {
    if (!menuPermissions.canDriverMaster) {
      return helpHttp().post4(  ENDPOINT, `shipping/getcountfiltershippingdriver`, token,  defaultStore.id, useraccount_id,  endedFlag, filtersShippingsDetails );
    }
    if (menuPermissions.canStoreMaster) {
      return helpHttp().post4(ENDPOINT,`shipping/getcountfiltershipping`,token,"-1","-1",endedFlag,filtersShippingsDetails);
    }
    if (menuPermissions.canUserMaster) {
      return helpHttp().post4(ENDPOINT,`shipping/getcountfiltershipping`, token,defaultStore.id,"-1",endedFlag,filtersShippingsDetails);
    }
    return helpHttp().post4(ENDPOINT,`shipping/getcountfiltershipping`,token,defaultStore.id,useraccount_id,filtersShippingsDetails);
  }, [defaultStore.id,filtersShippingsDetails,menuPermissions.canDriverMaster, menuPermissions.canStoreMaster,menuPermissions.canUserMaster,token, useraccount_id,endedFlag]);

  const resolveFormsRequest = useCallback(async () => {
    if (!menuPermissions.canDriverMaster) {
      return helpHttp().post6(ENDPOINT,`shipping/getshippingdriver`,token,currencyOffsetShipping,LIMIT_PAGE,"-1",useraccount_id,endedFlag,filtersShippingsDetails);
    }

    if (menuPermissions.canStoreMaster) { 
      return helpHttp().post6(ENDPOINT,`shipping/getshipping`,token,currencyOffsetShipping,LIMIT_PAGE,"-1","-1",endedFlag,filtersShippingsDetails);
    }
    if (menuPermissions.canUserMaster) {
      return helpHttp().post6( ENDPOINT, `shipping/getshipping`,token,currencyOffsetShipping,LIMIT_PAGE,defaultStore.id,"-1",endedFlag,filtersShippingsDetails);
    }
    return helpHttp().post6(ENDPOINT,`shipping/getshipping`,token,currencyOffsetShipping,LIMIT_PAGE,defaultStore.id,useraccount_id,endedFlag,filtersShippingsDetails);
  }, [currencyOffsetShipping,defaultStore.id,filtersShippingsDetails,menuPermissions.canDriverMaster,menuPermissions.canStoreMaster,menuPermissions.canUserMaster,token,useraccount_id,endedFlag]);

  const resolveInfoCountRequest = useCallback(async () => {
    // numTotRegFormDI
    if (!menuPermissions.canDriverMaster) {
      return helpHttp().get8( ENDPOINT, `shipping/getinformationtableshippingdriver`, token, useraccount_id,endedFlag);
    }
    if (menuPermissions.canStoreMaster) {
      return helpHttp().get2(ENDPOINT, `shipping/getinformationtableshipping/`, token, endedFlag);
    }
    if (menuPermissions.canUserMaster) { 
      helpHttp().get8(ENDPOINT,`shipping/getinformationtableshippingwithstore`,token,defaultStore.id,endedFlag)  
    }
    helpHttp().get7(ENDPOINT,`shipping/getinformationtableshippingwithstoreanduseraccount`,token,defaultStore.id,useraccount_id,endedFlag)  
  }, [defaultStore.id,   menuPermissions.canDriverMaster,menuPermissions.canStoreMaster,menuPermissions.canUserMaster,token, useraccount_id,endedFlag]);

  useEffect(() => {
    let alive = true;
    if (!showModalShippingsSettings && !refeshData) return;
    const run = async () => {
      try {
        const [info, count, forms] = await Promise.all([
          resolveInfoCountRequest(),
          resolveCountFilterRequest(),
          (async () => {
            dispatch(setLoading(true));
            return resolveFormsRequest();
          })(),
        ]);
        dispatch(setLoading(false));
        setRefeshData(false);
        if (!alive) return;
        const hasLoadFailed = (x) => x?.message === "Load failed";
        const isErr = (x) => x?.err || hasLoadFailed(x);
        if (isErr(info) || isErr(count)) {
          setDataShipping(initialStateShipping);
          if (hasLoadFailed(info) || hasLoadFailed(count)) {
            dispatch(warningErrorAction(t("Text_ConnectionFailied")));
          } else {
            dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          }
          return;
        }
        setNumTotRegShipping(info);
        setNumTotRegFilter(count);
        if (forms?.err) {
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        } else {
          setDataShipping(forms);
        }
      } catch {
        dispatch(setLoading(false));
        setRefeshData(false);
        if (!alive) return;
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }   
    };
    run();

  return () => {
      alive = false;
    };
  }, [
    dispatch,  
    resolveCountFilterRequest,
    resolveFormsRequest,
    resolveInfoCountRequest,
    showModalShippingsSettings,
    refeshData,
    t,
  ]); 

  const inputHandlerShipping = useCallback((e) => setInputTextShipping(safeLower(e.target.value)), []);
  const handleChangeDeleteRowShipping = useCallback((e) => setIdCodeDelete(e.target.value), []);
  const handleCancelDeleteRowShipping = useCallback(() => {
    setRowEditShipping(initialStateShipping[0]);
    setIsLoadingErrorShipping(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowShipping(false);
  }, [DELETE_CODE]);
  const handleChangeEnableReturnRowShipping = useCallback((e) => setIdCodeReturn(e.target.value), []);
  const handleCancelReturnRowShipping = useCallback(() => {
    setIdCodeReturn("");
    setOpenReturnRowShipping(false);
  }, []);

  const handleCloseDeleteRowShipping = useCallback(async (e) => {
    if (idCodeDelete !== DELETE_CODE_SHIPPING) {
      dispatch(warningErrorAction(t("Text_InvalidCode")));
      return;
    }
    if (e?.key === "Escape") return;
    if (rowEditShipping.id === "") {
      dispatch(warningErrorAction(t("Text_InvalidId")));
      return;
    }
    dispatch(setLoading(true));
    try {
      const deletedId = rowEditShipping.id;
      const getData = rowEditShipping.hasDeca
        ? await helpHttp().put(ENDPOINT, "shipping/annulshipping", token, { ...rowEditShipping, useraccount_id })
        : await helpHttp().del(ENDPOINT, "shipping/deleteshipping", token, rowEditShipping);
      if (getData?.status === "OK") {
        if (rowEditShipping.hasDeca && rowEditShipping.isFinished) {
          setDataShipping((current) => current.map((shipping) => Number(shipping.id) === Number(deletedId)
            ? { ...shipping, annulled: true, isFinished: true, isPending: false } : shipping));
        } else {
          setDataShipping((current) => current.filter(
            (shipping) => Number(shipping.id) !== Number(deletedId)
          ));
          setNumTotRegShipping((current) => Math.max(0, Number(current || 0) - 1));
          setNumTotRegFilter((current) => Math.max(0, Number(current || 0) - 1));
        }
        dispatch(successErrorAction(t(rowEditShipping.hasDeca ? "Text_Shipping_Annulled" : "Text_DeleteField")));
        setRefeshData(true);
        setRowEditShipping(initialStateShipping[0]);
        setIdCodeDelete(DELETE_CODE);
        setOpenDeleteRowShipping(false);
        setIsLoadingErrorShipping(false);
      } else {
        dispatch(warningErrorAction(t(getData?.cause || "Text_IncorrectData")));
      }
    } catch {
      dispatch(warningErrorAction(t("Text_IncorrectData")));
    } finally {
      dispatch(setLoading(false));
    }
  }, [DELETE_CODE, DELETE_CODE_SHIPPING, dispatch, idCodeDelete, rowEditShipping, t, token, useraccount_id]);

  const handleExport = useCallback(() => {
    if (!dataShipping || dataShipping.length === 0) return;
    const run = async () => {
      dispatch(setLoading(true));
      try {
        const getData = menuPermissions.canStoreMaster
          ? await helpHttp().post6( ENDPOINT, `shipping/getshippingtoexcel`, token,currencyOffsetShipping, LIMIT_PAGE,  "-1", "-1",endedFlag,filtersShippingsDetails)
          : menuPermissions.canUserMaster
          ? await helpHttp().post6( ENDPOINT, `shipping/getshippingtoexcel`, token, currencyOffsetShipping, LIMIT_PAGE, defaultStore.id, "-1", endedFlag, filtersShippingsDetails)
          : await helpHttp().post6(ENDPOINT,`shipping/getshippingtoexcel`,token,currencyOffsetShipping,LIMIT_PAGE,defaultStore.id,useraccount_id,endedFlag, filtersShippingsDetails);
        if (getData?.err) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        } else if (Array.isArray(getData) && getData.length > 0) {
          dispatch(setLoading(false));
          exportToExcel(getData, "CARTAS DE PORTES", i18n);
        }
      } catch {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      } 
    }; 
    run();
  }, [ i18n, currencyOffsetShipping, dataShipping,defaultStore.id, dispatch,filtersShippingsDetails,  menuPermissions.canStoreMaster,menuPermissions.canUserMaster, t, token,  useraccount_id,  endedFlag]);
 
  const handleExportSage = useCallback(() => {
    if (!dataShipping || dataShipping.length === 0) return;
    const run = async () => {
      dispatch(setLoading(true));
      try {
        const getData = menuPermissions.canStoreMaster
          ? await helpHttp().post6( ENDPOINT, `shipping/getshippingtosage`, token,currencyOffsetShipping, LIMIT_PAGE,  "-1", "-1",endedFlag,filtersShippingsDetails)
          : menuPermissions.canUserMaster
          ? await helpHttp().post6( ENDPOINT, `shipping/getshippingtosage`, token, currencyOffsetShipping, LIMIT_PAGE,  "-1", useraccount_id, endedFlag, filtersShippingsDetails)
          : await helpHttp().post6(ENDPOINT,`shipping/getshippingtosage`,token,defaultStore.id,useraccount_id,endedFlag, filtersShippingsDetails);
        if (getData?.err) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        } else if (Array.isArray(getData) && getData.length > 0) {
          dispatch(setLoading(false));
          exportToSAGE(getData, "CARTAS DE PORTES A SAGE", t,i18n);
        }
      } catch {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      } 
    }; 
    run();
  }, [ i18n, currencyOffsetShipping, dataShipping,defaultStore.id, dispatch,filtersShippingsDetails,  menuPermissions.canStoreMaster,menuPermissions.canUserMaster, t, token,  useraccount_id,  endedFlag]);
 
  const handleCancelCopyShipping = useCallback(() => {
    setRowEditShipping(initialStateShipping[0]);
    setIsLoadingErrorShipping(false);
    setNumberCopy(1);
    setOpenCopyRowShipping(false);
  }, []);

  const handleChangeCopyShipping = useCallback((e) => {
    const value = e.target.value;
    if (value === "") {
      setNumberCopy("");
      return;
    }
    const num = parseInt(value, 10);
    if (Number.isNaN(num)) return;
    if (num < 1) {
      setNumberCopy(1);
    } else if (num > 50) {
      setNumberCopy(50);
    } else {
      setNumberCopy(num);
    }
  }, []);  

  const handleCloseCopyRowShipping = useCallback(
    (e) => {
      if (e?.key === "Escape") return;
      if (rowEditShipping.id === "") {
        dispatch(warningErrorAction(t("Text_InvalidId")));
        return;
      }
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        try {
          const getData = await helpHttp().post2(ENDPOINT, `shipping/cloneshipping`,  token, numberCopy, rowEditShipping
          );
          if (alive) dispatch(setLoading(false));
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(successErrorAction(t("Text_SaveData")));
            setRefeshData(true);
            handleCloseDataEditShipping();
            const clonedShippingIds = Array.isArray(getData.response)
              ? getData.response
              : [];
            if (menuPermissions.canAutoDeca && clonedShippingIds.length > 0) {
              const waitForDeca = async (shippingId) => {
                let result = { status: "ACCEPTED" };
                for (let attempt = 0;
                  result.status === "ACCEPTED" && attempt < 180;
                  attempt += 1) {
                  await new Promise((resolve) => setTimeout(resolve, 1000));
                  result = await helpHttp().get(
                    ENDPOINT,
                    `shipping/generatedeca/status/${shippingId}`,
                    token
                  );
                }
                return result;
              };
              const decaResults = await Promise.all(
                clonedShippingIds.map(waitForDeca)
              );
              if (decaResults.every((result) => result?.status === "OK")) {
                dispatch(successErrorAction(t("Text_DeCA_Generated")));
              } else if (decaResults.some(
                (result) => result?.cause === "Text_DeCA_MissingFields"
              )) {
                dispatch(warningErrorAction(t("Text_DeCA_Incomplete")));
              } else {
                dispatch(warningErrorAction(t("Text_DeCA_AutomaticError")));
              }
              setRefeshData(true);
            }
          } else {
            dispatch(warningErrorAction(t(getData?.cause || "Text_IncorrectData")));
          }
        } catch {
          if (alive) dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        } 
      };
      run();
      setIdCodeDelete(DELETE_CODE);
      setOpenDeleteRowShipping(false);
      setIsLoadingErrorShipping(false);
      handleCloseDataEditShipping();
      return () => {
        alive = false;
      };
    },[DELETE_CODE, dispatch,handleCloseDataEditShipping, menuPermissions.canAutoDeca, numberCopy,rowEditShipping,t,token]); 

    useEffect(() => {
    if (!openEditFilterShipping || !menuPermissions.canDriverMaster || !menuPermissions.canStoreMaster || !menuPermissions.canUserMaster) return;
    let active = true;
    const loadUsers = async () => {
      try {
        const users = await helpHttp().post(ENDPOINT, `shipping/filtercreatorusers/${endedFlag}`, token, filtersShippingsDetails);
        if (!Array.isArray(users)) throw new Error('Invalid users');
        if (active) setFilterUsers(users.map((username) => ({ id: username, username })));
      } catch (error) {
        if (active) dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    loadUsers();
    return () => { active = false; };
  }, [openEditFilterShipping, menuPermissions.canDriverMaster, menuPermissions.canStoreMaster, menuPermissions.canUserMaster, token, dispatch, t, endedFlag, filtersShippingsDetails]);

  return (
    <>
       {showModalShippingsSettings ? ( 
          <div className="container-fluid formdi-pending-page shipping-list-content">
            {/* Search input */}
            <div id="myDIV" className="formdi-pending-header">
              <h1 className={!endedFlag ? "hANewStyle mb-2" : "hBNewStyle mb-2"}>
                {isLoadingErrorShipping?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRowShipping?"warning":"primary"}/>:<i className="fas fa-truck text-warning"></i>} {!endedFlag ?t('Text_Shippings_Table_PENDING'):t('Text_Shippings_Table_ENDED')}
              </h1>
              {menuPermissions.canFormCreate? (
                <div>
                  <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditDataShipping} >
                    {t("Button_Create")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={openModalReturn}>
                    {!endedFlag ? t("Button_FinishShort") : t("Button_PendingShort")}
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalShipping} >
                    {t("Button_Back")}
                  </button>
                </div>
              ) : (
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalShipping} >
                    {t("Button_Back")}
                  </button>
                </div>
              )} 
            </div>  
            <br/>
            <div className="formdi-pending-search">
              <TextField
                id="outlined-basic"
                variant="outlined" 
                value={inputTextShipping}
                inputProps={{ style: {fontSize: '18px'} }}
                InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
                placeholder={t('Text_SHIPPING_Search')} 
                onChange={inputHandlerShipping}
                fullWidth
                label={t('Text_SHIPPING_Search')}>
              </TextField>
            </div>
          <br/>

          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersShippingsDetails.idFrom !== "" || filtersShippingsDetails.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersShipping} >
                <span className={`formdi-pending-dot ${ filtersShippingsDetails.idFrom !== "" || filtersShippingsDetails.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>

              { menuPermissions.canDriverMaster && menuPermissions.canStoreMaster && (
                <>
                 <button type="button" className={`formdi-pending-chip ${filtersShippingsDetails.defaultStoreIdFrom !== "" || filtersShippingsDetails.defaultStoreIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersShipping} >
                    <span className={`formdi-pending-dot ${ filtersShippingsDetails.defaultStoreIdFrom !== "" || filtersShippingsDetails.defaultStoreIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                      {t("Text_Store")}
                  </button> 
                </>
              )}
              { menuPermissions.canDriverMaster && menuPermissions.canStoreMaster && menuPermissions.canUserMaster && (
                <>
                  <button type="button" className={`formdi-pending-chip ${filtersShippingsDetails.useraccountIdFrom !== "" || filtersShippingsDetails.useraccountIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersShipping} >
                    <span className={`formdi-pending-dot ${ filtersShippingsDetails.useraccountIdFrom !== "" || filtersShippingsDetails.useraccountIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                      {t("Text_UserAccount")}
                  </button>
                </>
              )}
              <button type="button" className={`formdi-pending-chip ${filtersShippingsDetails.numberShippingFrom !== "" || filtersShippingsDetails.numberShippingTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersShipping} >
                <span className={`formdi-pending-dot ${ filtersShippingsDetails.numberShippingFrom !== "" || filtersShippingsDetails.numberShippingTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Number")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersShippingsDetails.dateShippingFrom !== null || filtersShippingsDetails.dateShippingTo !== null ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersShipping} >
                <span className={`formdi-pending-dot ${ filtersShippingsDetails.dateShippingFrom !== null || filtersShippingsDetails.dateShippingTo !== null? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Date")}
              </button>
              <button type="button" className={`formdi-pending-chip ${
                    filtersShippingsDetails.ori_tras_store_idFrom!=="" ||
                          filtersShippingsDetails.ori_tras_store_idTo!=="" ||
                          filtersShippingsDetails.dest_tras_store_idFrom!=="" || 
                          filtersShippingsDetails.dest_tras_store_idTo!=="" ||
                          filtersShippingsDetails.rel_trans_store_idFrom!=="" ||
                          filtersShippingsDetails.rel_trans_store_idTo!=="" ||
                          filtersShippingsDetails.vehicleFrom!=="" ||
                          filtersShippingsDetails.vehicleTo!==""? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersShipping} >
                <span className={`formdi-pending-dot ${ 
                    filtersShippingsDetails.ori_tras_store_idFrom!=="" ||
                          filtersShippingsDetails.ori_tras_store_idTo!=="" ||
                          filtersShippingsDetails.dest_tras_store_idFrom!=="" || 
                          filtersShippingsDetails.dest_tras_store_idTo!=="" ||
                          filtersShippingsDetails.rel_trans_store_idFrom!=="" ||
                          filtersShippingsDetails.rel_trans_store_idTo!=="" ||
                          filtersShippingsDetails.vehicleFrom!=="" ||
                          filtersShippingsDetails.vehicleTo!==""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Others_Filters")}
              </button>
              {menuPermissions.canFormExcel &&
                 <>
                  <button type="button" className="formdi-pdf-chip" onClick={handleExportPDF}>
                    {t("Button_PDF")}
                  </button>
                </>
              }  
              {menuPermissions.canFormEmail &&
                <>
                  <button type="button" className="formdi-email-chip" onClick={handleSendEmailList}>
                    {t("Button_SEND_EMAIL_LIST")}
                    <SendIcon sx={{ fontSize: 22, color: "white" }} />
                  </button>
                </>
              }
              {menuPermissions.canFormExcel &&
                 <>
                  <button type="button" className="formdi-excel-chip" onClick={handleExport}>{t('Button_Excel')}</button><> </> 
                </>
              }
              {menuPermissions.canFormExcel && (
                <>
                  <button type="button" className="formdi-pdf-chip" disabled={Boolean(downloadJob)} onClick={() => downloadSelectedShipping('pdf')}>
                    {t('Button_SHIPPING_PDF_SELECT')}
                  </button>
                  <button type="button" className="formdi-zip-chip" disabled={Boolean(downloadJob)} onClick={() => downloadSelectedShipping('zip')}>
                    {t('Button_SHIPPING_ZIP_SELECT')}
                  </button>
                </>
              )}
              {menuPermissions.canFormSage && (
                <button type="button" className="formdi-sage-chip" onClick={handleExportSage}>
                  {t("Button_SAGE")}
                </button>
              )}
            </div>
          </div>
          <br/>
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingShipping
                    dataShipping={filteredDataShipping} 
                    setDataShipping={setDataShipping} 
                    setFormPShipping={setFormPShipping}
                    formPShipping={formPShipping}
                    numTotRegFilter={ numTotRegFilter}
                    titleTable={t('Text_SHIPPING_Table')}
                    setOpenDeleteRowShipping={setOpenDeleteRowShipping}
                    setRowEditShipping={setRowEditShipping}
                    showEditButtonShipping={menuPermissions.canFormEdit}
                    canViewCheck={menuPermissions.canViewCheck}
                    showPrintButtonShipping={menuPermissions.canFormPrint}
                    showDecaHistory={menuPermissions.canDecaHistory}
                    showDeleteButtonShipping={menuPermissions.canFormDelete}
                    showFormShipping={menuPermissions.canShipping}
                    showEmailButtonShipping={menuPermissions.canFormEmail}
                    showFinishButtonhipping={menuPermissions.canEnded}
                    showStoreShipping={menuPermissions.canStoreMaster}
                    showUserAccountShipping={menuPermissions.canUserMaster}
                    showTotal={menuPermissions.canViewPrice}
                    showFormDI={menuPermissions.canViewFormDI}
                    showReference={menuPermissions.canViewReference}
                    showOptTras={menuPermissions.canViewOptTras}
                    setOpenViewFormDI={setOpenViewFormDI}
                    numTotRegShipping={numTotRegShipping}
                    activeOffsetShipping={activeOffsetShipping}
                    rangeOffsetShipping={rangeOffsetShipping}
                    currencyOffsetShipping={currencyOffsetShipping}
                    setCurrencyOffsetShipping={setCurrencyOffsetShipping} 
                    setOpenCopyRowShipping={setOpenCopyRowShipping}
                    setViewPDF={setViewPDF} 
                    typeOfList={typeOfList}
                  > 
                  </TableSortingShipping>
                </div>             
              </div>
              
              {openEditFilterShipping &&
               <div>
               <SwipeableDrawer
                 PaperProps={{ className: 'shipping-list-filter-panel' }}
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditShipping(false)}
                 onOpen={toggleDrawerFilterEditShipping(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfiltershipping" onSubmit={handleCancelFiltersShipping}>  
                         <div className="form-floating mb-3 px-4 primary">
                            {menuPermissions.canDriverMaster && menuPermissions.canStoreMaster && menuPermissions.canUserMaster && (
                              <div className="form-group">
                                {['From', 'To'].map((boundary) => {
                                  const name = `useraccountId${boundary}`;
                                
  return (
                                    <TextField
                                      select
                                      sx={{ width: 430 }}
                                      key={name}
                                      id={name}
                                      name={name}
                                      value={filtersShipping[name]}
                                      inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                      InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                      label={t(errorsFiltersShipping[name] || `Text_Filter_UserAccount_${boundary}`)}
                                      placeholder={t(`PlaceHolder_UserAccount_${boundary}`)}
                                      error={Boolean(errorsFiltersShipping[name])}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditShipping}
                                      onChange={handleChangeFilterEditShipping}
                                    >
                                      <MenuItem value=""><em>—</em></MenuItem>
                                      {filtersShipping[name] && !filterUsers.some((user) => user.username === filtersShipping[name]) && (
                                        <MenuItem value={filtersShipping[name]}>{filtersShipping[name]}</MenuItem>
                                      )}
                                      {filterUsers
                                        .filter((user) => boundary !== 'To' || !filtersShipping.useraccountIdFrom || user.username >= filtersShipping.useraccountIdFrom)
                                        .sort((a, b) => a.username < b.username ? -1 : a.username > b.username ? 1 : 0)
                                        .map((user) => (
                                          <MenuItem key={user.id} value={user.username}>{user.username}</MenuItem>
                                        ))}
                                    </TextField>
                                  );
                                })}
                              </div>
                            )}
                            <div className="form-group">
                              <TextField
                                id="idFrom" 
                                name="idFrom"
                                value={filtersShipping.idFrom}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsFiltersShipping.idFrom!=null?t(errorsFiltersShipping.idFrom):t('Text_Filter_Code_From')}
                                placeholder={t('PlaceHolder_Filter_Code_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditShipping}
                                onChange={handleChangeFilterEditShipping}/>
                               
                              <TextField
                                id="idTo" 
                                name="idTo"
                                value={filtersShipping.idTo}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsFiltersShipping.idTo!=null?t(errorsFiltersShipping.idTo):t('Text_Filter_Code_To')}
                                placeholder={t('PlaceHolder_Filter_Code_to')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditShipping}
                                onChange={handleChangeFilterEditShipping}/>
                            </div>
                            
                            <div className="form-group">
                              <TextField
                              id="numberShippingFrom" 
                              name="numberShippingFrom"
                              value={filtersShipping.numberShippingFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersShipping.numberShippingFrom!=null?t(errorsFiltersShipping.numberShippingFrom):t('Text_Filter_Number_From')}
                              placeholder={t('PlaceHolder_Filter_Number_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditShipping}
                              onChange={handleChangeFilterEditShipping}/>
                               
                              <TextField
                              id="numberShippingTo" 
                              name="numberShippingTo"
                              value={filtersShipping.numberShippingTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersShipping.numberShippingTo!=null?t(errorsFiltersShipping.numberShippingTo):t('Text_Filter_Number_To')}
                              placeholder={t('PlaceHolder_Filter_Number_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditShipping}
                              onChange={handleChangeFilterEditShipping}/>
                            </div>
                         
                            <div className="form-group">
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                <DesktopDatePicker
                                  id="dateShippingFrom" 
                                  name="dateShippingFrom"
                                  value={ filtersShipping.dateShippingFrom!== null ? new Date(filtersShipping.dateShippingFrom): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsFiltersShipping.dateShippingFrom!=null?t(errorsFiltersShipping.dateShippingFrom):t('PlaceHolder_Filter_DateSheet_From')}
                                  onBlur={handleBlurSelectDateShippingFrom}
                                  onChange={handleChangeSelectDateShipping}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                               
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                <DesktopDatePicker
                                  id="dateShippingTo" 
                                  name="dateShippingTo"
                                  minDate={filtersShipping.dateShippingFrom!== null ? new Date(filtersShipping.dateShippingFrom): null}
                                  value={ filtersShipping.dateShippingTo!== null ? new Date(filtersShipping.dateShippingTo): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsFiltersShipping.dateShippingTo!=null?t(errorsFiltersShipping.dateShippingTo):t('PlaceHolder_Filter_DateSheet_To')}
                                  onBlur={handleBlurSelectDateShippingTo}
                                  onChange={handleChangeSelectDateShippingTo}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </div>   
                          {/* DEST FROM / TO */}
                          <div className="form-group">
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="dest_tras_store_idFrom"
                                name="dest_tras_store_idFrom"
                                value={filtersShipping.dest_tras_store_idFrom}
                                onChange={(e) => {
                                  const v = upper(e.target.value);
                                  setFiltersShipping((p) => ({
                                    ...p,
                                    dest_tras_store_idFrom: v,
                                    dest_tras_store_idTo: v,
                                  }));
                                  destAuto.debouncedSearchFrom(v);
                                }}
                                onKeyDown={destAuto.keyDownFrom}
                                onBlur={(event) => {
                                  if (
                                    !event.relatedTarget ||
                                    !event.relatedTarget.closest(".dropdown-class")
                                  ) {
                                    handleBlurAutocomplete(event);
                                  }
                                }}
                                label={
                                  errorsFiltersShipping.dest_tras_store_idFrom != null
                                    ? t(errorsFiltersShipping.dest_tras_store_idFrom)
                                    : t("Text_Filter_DestTras_From")
                                }
                                placeholder={t("PlaceHolder_Filter_DestTras_From")}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                variant="outlined"
                              />

                              {destAuto.filteredFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: "0px",
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: "18px",
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {destAuto.filteredFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => destAuto.selectFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: "18px",
                                        backgroundColor:
                                          index === destAuto.hiFrom ? "#4e73df" : "transparent",
                                        color: index === destAuto.hiFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>

                            

                            <span style={{ position: "relative" }}>
                              <TextField
                                id="dest_tras_store_idTo"
                                name="dest_tras_store_idTo"
                                value={filtersShipping.dest_tras_store_idTo}
                                onChange={(e) => {
                                  const v = upper(e.target.value);
                                  setFiltersShipping((p) => ({ ...p, dest_tras_store_idTo: v }));
                                  destAuto.debouncedSearchTo(v);
                                }}
                                onKeyDown={destAuto.keyDownTo}
                                onBlur={(event) => {
                                  if (
                                    !event.relatedTarget ||
                                    !event.relatedTarget.closest(".dropdown-class")
                                  ) {
                                    handleBlurAutocomplete(event);
                                  }
                                }}
                                label={
                                  errorsFiltersShipping.dest_tras_store_idTo != null
                                    ? t(errorsFiltersShipping.dest_tras_store_idTo)
                                    : t("Text_Filter_DestTras_To")
                                }
                                placeholder={t("PlaceHolder_Filter_DestTras_To")}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                variant="outlined"
                              />

                              {destAuto.filteredTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: "0px",
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: "18px",
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {destAuto.filteredTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => destAuto.selectTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: "18px",
                                        backgroundColor:
                                          index === destAuto.hiTo ? "#4e73df" : "transparent",
                                        color: index === destAuto.hiTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div>
 
                        {/* ORI FROM / TO */}
                          <div className="form-group">
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="ori_tras_store_idFrom"
                                name="ori_tras_store_idFrom"
                                value={filtersShipping.ori_tras_store_idFrom}
                                onChange={(e) => {
                                  const v = upper(e.target.value);
                                  setFiltersShipping((p) => ({
                                    ...p,
                                    ori_tras_store_idFrom: v,
                                    ori_tras_store_idTo: v,
                                  }));
                                  oriAuto.debouncedSearchFrom(v);
                                }}
                                onKeyDown={oriAuto.keyDownFrom}
                                onBlur={(event) => {
                                  if (
                                    !event.relatedTarget ||
                                    !event.relatedTarget.closest(".dropdown-class")
                                  ) {
                                    handleBlurAutocomplete(event);
                                  }
                                }}
                                label={
                                  errorsFiltersShipping.ori_tras_store_idFrom != null
                                    ? t(errorsFiltersShipping.ori_tras_store_idFrom)
                                    : t("Text_Filter_OriTras_From")
                                }
                                placeholder={t("PlaceHolder_Filter_OriTras_From")}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                variant="outlined"
                              />

                              {oriAuto.filteredFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: "0px",
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: "18px",
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {oriAuto.filteredFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => oriAuto.selectFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: "18px",
                                        backgroundColor:
                                          index === oriAuto.hiFrom ? "#4e73df" : "transparent",
                                        color: index === oriAuto.hiFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>

                            

                            <span style={{ position: "relative" }}>
                              <TextField
                                id="ori_tras_store_idTo"
                                name="ori_tras_store_idTo"
                                value={filtersShipping.ori_tras_store_idTo}
                                onChange={(e) => {
                                  const v = upper(e.target.value);
                                  setFiltersShipping((p) => ({ ...p, ori_tras_store_idTo: v }));
                                  oriAuto.debouncedSearchTo(v);
                                }}
                                onKeyDown={oriAuto.keyDownTo}
                                onBlur={(event) => {
                                  if (
                                    !event.relatedTarget ||
                                    !event.relatedTarget.closest(".dropdown-class")
                                  ) {
                                    handleBlurAutocomplete(event);
                                  }
                                }}
                                label={
                                  errorsFiltersShipping.ori_tras_store_idTo != null
                                    ? t(errorsFiltersShipping.ori_tras_store_idTo)
                                    : t("Text_Filter_OriTras_To")
                                }
                                placeholder={t("PlaceHolder_Filter_OriTras_To")}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                variant="outlined"
                              />

                              {oriAuto.filteredTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: "0px",
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: "18px",
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {oriAuto.filteredTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => oriAuto.selectTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: "18px",
                                        backgroundColor:
                                          index === oriAuto.hiTo ? "#4e73df" : "transparent",
                                        color: index === oriAuto.hiTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div>

                          {/* TRANS FROM / TO */}
                            {menuPermissions.canDriverMaster && (
                              <div className="form-group">
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="rel_trans_store_idFrom"
                                    name="rel_trans_store_idFrom"
                                    value={filtersShipping.rel_trans_store_idFrom}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersShipping((p) => ({
                                        ...p,
                                        rel_trans_store_idFrom: v,
                                        rel_trans_store_idTo: v,
                                      }));
                                      transAuto.debouncedSearchFrom(v);
                                    }}
                                    onKeyDown={transAuto.keyDownFrom}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersShipping.rel_trans_store_idFrom != null
                                        ? t(errorsFiltersShipping.rel_trans_store_idFrom)
                                        : t("Text_Filter_Trans_From")
                                    }
                                    placeholder={t("PlaceHolder_Filter_Trans_From")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {transAuto.filteredFrom.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {transAuto.filteredFrom.map((store, index) => (
                                        <MenuItem
                                          key={store.id}
                                          onClick={() => transAuto.selectFrom(store)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === transAuto.hiFrom ? "#4e73df" : "transparent",
                                            color: index === transAuto.hiFrom ? "white" : "black",
                                          }}
                                        >
                                          {store.documentid} - {store.tradename}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>

                                

                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="rel_trans_store_idTo"
                                    name="rel_trans_store_idTo"
                                    value={filtersShipping.rel_trans_store_idTo}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersShipping((p) => ({ ...p, rel_trans_store_idTo: v }));
                                      transAuto.debouncedSearchTo(v);
                                    }}
                                    onKeyDown={transAuto.keyDownTo}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersShipping.rel_trans_store_idTo != null
                                        ? t(errorsFiltersShipping.rel_trans_store_idTo)
                                        : t("Text_Filter_Trans_To")
                                    }
                                    placeholder={t("PlaceHolder_Filter_Trans_To")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {transAuto.filteredTo.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {transAuto.filteredTo.map((store, index) => (
                                        <MenuItem
                                          key={store.id}
                                          onClick={() => transAuto.selectTo(store)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === transAuto.hiTo ? "#4e73df" : "transparent",
                                            color: index === transAuto.hiTo ? "white" : "black",
                                          }}
                                        >
                                          {store.documentid} - {store.tradename}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>
                              </div>
                            )}

                            {/* VEHICLE FROM / TO */}
                            {menuPermissions.canDriverMaster && (
                              <div className="form-group">
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="vehicleFrom"
                                    name="vehicleFrom"
                                    value={filtersShipping.vehicleFrom}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersShipping((p) => ({
                                        ...p,
                                        vehicleFrom: v,
                                        vehicleTo: v,
                                      }));
                                      vehicleAuto.debouncedSearchFrom(v);
                                    }}
                                    onKeyDown={vehicleAuto.keyDownFrom}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersShipping.vehicleFrom != null
                                        ? t(errorsFiltersShipping.vehicleFrom)
                                        : t("Text_Filter_LicensePlate_From")
                                    }
                                    placeholder={t("PlaceHolder_Filter_LicensePlate_From")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {vehicleAuto.filteredFrom.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {vehicleAuto.filteredFrom.map((vehicle, index) => (
                                        <MenuItem
                                          key={vehicle.id}
                                          onClick={() => vehicleAuto.selectFrom(vehicle)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === vehicleAuto.hiFrom ? "#4e73df" : "transparent",
                                            color: index === vehicleAuto.hiFrom ? "white" : "black",
                                          }}
                                        >
                                          {vehicle.vehiclestore_licenseplate}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>

                                

                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="vehicleTo"
                                    name="vehicleTo"
                                    value={filtersShipping.vehicleTo}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersShipping((p) => ({ ...p, vehicleTo: v }));
                                      vehicleAuto.debouncedSearchTo(v);
                                    }}
                                    onKeyDown={vehicleAuto.keyDownTo}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersShipping.vehicleTo != null
                                        ? t(errorsFiltersShipping.vehicleTo)
                                        : t("Text_Filter_LicensePlate_To")
                                    }
                                    placeholder={t("PlaceHolder_Filter_LicensePlate_To")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {vehicleAuto.filteredTo.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {vehicleAuto.filteredTo.map((vehicle, index) => (
                                        <MenuItem
                                          key={vehicle.id}
                                          onClick={() => vehicleAuto.selectTo(vehicle)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === vehicleAuto.hiTo ? "#4e73df" : "transparent",
                                            color: index === vehicleAuto.hiTo ? "white" : "black",
                                          }}
                                        >
                                          {vehicle.vehiclestore_licenseplate}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>
                              </div>
                            )}
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditShipping}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersShipping}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>  
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
              </div>
              }  
              <FormDIView 
                openViewFormDI={openViewFormDI} 
                setOpenViewFormDI={setOpenViewFormDI} 
                rowEditShipping={rowEditShipping}
              />
              <ShippingPDF 
                rowEditShipping={rowEditShipping} 
                viewPDF={viewPDF} 
                setViewPDF={setViewPDF}
              />

              {/* Dialog Return/Finish */}
              <Dialog open={openReturnRowShipping} onClose={handleCancelReturnRowShipping} PaperProps={{ className: "my-dialog-blue-paper" }}>
                <DialogTitle className="my-dialog-blue-title">{!endedFlag ? t("Button_Finish") : t("Button_Pending")}</DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-blue-contentText">{t("Text_Line9")}</DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label_Confirma")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-blue-input"
                    placeholder={CONFIRM_CODE}
                    defaultValue={idCodeReturn || ""}
                    onChange={handleChangeEnableReturnRowShipping}
                  />
                </DialogContent>
                <DialogActions className="my-dialog-blue-actions">
                  <Button onClick={handleCancelReturnRowShipping} className="my-dialog-blue-button-cancel">
                    {t("Button_Cancel")}
                  </Button>
                  <Button variant="contained" onClick={handleFinishSelectedShipping} className="my-dialog-blue-button-copy">
                    {t("Button_CONFiRM")}
                  </Button>
                </DialogActions>
              </Dialog>
              
              <Dialog open={openDeleteRowShipping} onClose={handleCancelDeleteRowShipping} PaperProps={{ className: "my-dialog-paper-danger" }} >
                <DialogTitle className="my-dialog-title-danger">
                  {t(rowEditShipping.hasDeca ? 'Button_AnnulShipping' : 'Text_Delete')} {rowEditShipping.id}  - {rowEditShipping.number_shipping} - {rowEditShipping.opt_tras_tradename}
                </DialogTitle>
                  <DialogContent>
                    <DialogContentText className="my-dialog-contentText-danger">
                      {t(rowEditShipping.hasDeca ? "Text_Shipping_AnnulConfirm" : "Text_Line1")}<br />
                      {t("Text_Line2")}
                    </DialogContentText>
                      <TextField
                        autoFocus
                        autoComplete="off"
                        margin="dense"
                        id="idCode"
                        label={t("Text_Label")}
                        type="text"
                        fullWidth
                        variant="standard"
                        className="my-dialog-input-danger"
                        defaultValue={idCodeDelete}
                        onChange={handleChangeDeleteRowShipping}
                      />
                    </DialogContent>
                  <DialogActions className="my-dialog-actions">
                  <Button
                    onClick={handleCancelDeleteRowShipping}
                    className="my-dialog-button-cancel-danger"
                  >
                    {t("Button_Cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloseDeleteRowShipping}
                    className="my-dialog-button-delete"
                  >
                    {t(rowEditShipping.hasDeca ? "Button_AnnulShipping" : "Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog> 

              <Dialog open={openCopyRowShipping} onClose={handleCancelCopyShipping} PaperProps={{ className: "my-dialog-paper" }}>
                <DialogTitle className="my-dialog-title">
                  {t("Text_Copy")}: {rowEditShipping.ownshipping_id}
                  {rowEditShipping.number_shipping}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText">
                    {t("Text_Line1_Copy")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="numberCopy"
                      label={t("Text_Label_Copy")}
                      type="number"
                      inputProps={{ min: 1, max: 50, step: 1 }}
                      fullWidth
                      variant="standard"
                      className="my-dialog-input"
                      value={numberCopy}
                      onChange={handleChangeCopyShipping}
                    />
                </DialogContent>
                <DialogActions className="my-dialog-actions">
                  <Button onClick={handleCancelCopyShipping} className="my-dialog-button-cancel">
                    {t("Button_Cancel")}
                  </Button>
                  <Button variant="contained" onClick={handleCloseCopyRowShipping} className="my-dialog-button-copy">
                    {t("Button_Copy")}
                  </Button>
                </DialogActions>
              </Dialog>
              {/* End Content Row */}
          </>:
            <LoadingNews/> 
          }
        </div>
        //* End Page Content *//
      ) :  null }
      {downloadJob && <ShippingBatchDownload job={downloadJob} onComplete={completeDownload} onError={failDownload} />}
    </>
  )
}

ShippingFilter.propTypes = {
  showModalShippingsSettings: PropTypes.bool.isRequired,
  setShowModalShippingsSettings: PropTypes.func.isRequired
};

export default ShippingFilter;
